// React-Query key for the active label card. A selected document id (from the
// /labeling/$documentId route) keys a targeted claim; null keys the queue's
// next card. Shared so the query and its invalidation can't drift apart.
export function cardQueryKey(selectedDocumentId: string | null) {
  return ['labeling', 'card', selectedDocumentId ?? 'next'] as const;
}
